import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { marqueeItems } from '../data/content';
export function Marquee() {
  const reduceMotion = useReducedMotion();
  const items = [...marqueeItems, ...marqueeItems];
  const row = <div className="flex shrink-0 items-center" data-id="element-150" data-mp="2ijxcu473k32d">
      {items.map((item, index) => <span key={`${item}-${index}`} className="flex items-center whitespace-nowrap px-6 text-sm font-extrabold uppercase tracking-[0.16em] text-ink" data-id="element-151" data-mp="2dm5k57ymocx4" data-mpi={index}>
          {item}
          <span className="ml-6 inline-block h-1.5 w-1.5 rounded-full bg-ink/40" aria-hidden="true" data-id="element-152" data-mp="369roiifojll1" />
        </span>)}
    </div>;
  return <div className="w-full overflow-hidden border-y-2 border-ink bg-volt py-3.5" aria-hidden="true" data-id="element-153" data-mp="2x7igbz7vw4at">
      {reduceMotion ? <div className="flex justify-center" data-id="element-154" data-mp="1psnfbvoiia09">{row}</div> : <motion.div className="flex w-max" animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration: 26,
      ease: 'linear',
      repeat: Infinity
    }} data-id="element-155" data-mp="1lrtr1175qt6u">
          {row}
          {row}
        </motion.div>}
    </div>;
}